export const AI_CONTRACT_CLASSES: readonly string[] = [
  'ai-answer',
  'ai-title',
  'ai-section',
  'ai-section-title',
  'ai-kv',
  'ai-kv-item',
  'ai-kv-label',
  'ai-kv-value',
  'ai-note',
  'ai-status',
  'ai-status--ok',
  'ai-status--warn',
  'ai-status--danger',
  'ai-table',
];

export type AiStatus = 'ok' | 'warn' | 'danger';

export const STATUS_KEYWORDS: ReadonlyArray<{ status: AiStatus; pattern: RegExp }> = [
  { status: 'danger', pattern: /\b(fuera de rango|cr[ií]tico|cr[ií]tica|anormal|alterado|alterada|elevado|elevada|alto|alta|bajo|baja|severo|severa)\b/i },
  { status: 'warn', pattern: /\b(l[ií]mite|lim[ií]trofe|borderline|moderado|moderada|leve|vigilar|precauci[oó]n)\b/i },
  { status: 'ok', pattern: /\b(normal|dentro de rango|sin alteraciones|sin hallazgos|estable|adecuado|adecuada)\b/i },
];

export const EXPLICIT_STATUS_CLASS: Readonly<Record<string, AiStatus>> = {
  'ai-status--ok': 'ok',
  'ai-status--warn': 'warn',
  'ai-status--danger': 'danger',
};

export const HEADING_TAGS = new Set(['H1', 'H2', 'H3', 'H4', 'H5', 'H6']);
export const ALLOWED_CLASS_SET = new Set<string>(AI_CONTRACT_CLASSES);
export const INLINE_TAGS = new Set(['STRONG', 'EM', 'B', 'I', 'U', 'SMALL', 'SPAN', 'BR', 'A']);
export const FLATTEN_TAGS = new Set(['DIV', 'ARTICLE', 'HEADER', 'FOOTER', 'SECTION']);
export const STRUCTURAL_TABLE_TAGS = new Set(['THEAD', 'TBODY', 'TFOOT', 'TR', 'TD', 'TH']);
